import Vue from "vue";
import VueRouter from "vue-router";
import logout from "../pages/logout.vue";
import companyDashboard from "./companyDashboard";
import frontApp from "./frontApp";
import About from "../pages/Front/About";

Vue.use(VueRouter);

const routes = [
  companyDashboard,
  frontApp,
  {
    path: "/logout",
    component: logout,
    name: "logout",
    meta: {
      requiresAuth: true,
      title:'Logout'
    },
  },
  {
    path: "/about",
    name: "about",
    component: About,
    meta:{
      title:'About Us'
    },
  },
  {
    path: "/modules",
    name: "modules",
    component: () => import("../pages/Front/Modules.vue"),

  },
  {
    path: "/registration",
    name: "register",
    meta:{
      title:'Login'
    },
    component: () => import("../pages/register.vue"),
  },
  {
    path: "/login",
    name: "login",
    meta:{
      title:'Login'
    },
    component: () => import("../pages/login.vue"),
  },
  {
    path: "/404",
    meta:{
      title:'404'
    },
    component: () => import("../pages/errorPage.vue"),
  },
  {
    path: "*",
    redirect: "/404",
  },

];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
